import Tab from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';
import { Card } from '../../../component';
import useTheme from '../../../utilities/hooks/theme';

interface CreateTeamTabBarProps {
  onChangeTab?: any;
  counts?: any;
  activeTab?: number;
  routes?: any;
}

const CreateTeamTabBar = ({ onChangeTab, activeTab, counts, routes }: CreateTeamTabBarProps) => {
  const { FantasyTheme: theme } = useTheme();

  return (
    <Card
      style={{
        borderRadius: '0px',
        backgroundColor: 'transparent',
        width: '100%'
      }}>
      <Tabs
        onChange={onChangeTab}
        value={activeTab}
        style={{
          minHeight: 0,
          padding: 0
        }}
        TabIndicatorProps={{ style: { background: '#F6CE3F' } }}>
        {routes.map((item: { title: string | number }, index: any) => {
          const tabActive = activeTab === index;

          return (
            <Tab
              style={{
                flex: 1,
                minHeight: 0,
                padding: 0,
                background: tabActive
                  ? theme.createTeamTabBarActiveRoleTypeBG
                  : theme.createTeamTabBarDefaultRoleTypeBG,
                fontSize: '1.1rem',
                height: '40px',
                fontFamily: tabActive ? 'ProximaNova-Bold' : 'ProximaNova-Regular',
                color: tabActive
                  ? theme.createTeamTabBarActiveRoleTypeTitle
                  : theme.createTeamTabBarDefaultRoleTypeTitle,
                border: `1px solid ${theme.createTeamTabBarBorder}`
              }}
              key={item.title}
              label={`${item.title} (${counts[item.title]})`}
              value={index}
            />
          );
        })}
      </Tabs>
    </Card>
  );
};
export default React.memo(CreateTeamTabBar);
